<template>
	<div>
		<v-navigation-drawer temporary app v-model="drawer">
			<v-list nav>
				<v-list-item-group v-model="item" color="primary">
					<v-list-item v-for="(item, i) in items" :key="i" :to="item.to">
						<v-list-item-icon>
							<v-icon v-text="item.icon"></v-icon>
						</v-list-item-icon>
						<!-- <v-list-item-content> -->
						<v-list-item-title v-text="item.text"></v-list-item-title>
						<!-- </v-list-item-content> -->
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>

		<v-app-bar app color="indigo" dark>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer" />
			<v-toolbar-title>{{ $t('pages.' + ($route.name || '/')) }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-title>{{ user !== null ? user.name : '' }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="logout">
				<v-icon>mdi-logout</v-icon>
			</v-btn>
		</v-app-bar>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'TheNavigation',

	computed: {
		...mapGetters({
			user: 'auth/user'
		})
	},

	data() {
		return {
			drawer: false,
			item: null,
			items: [
				{ text: this.$t('pages./'), icon: 'mdi-view-dashboard-outline', to: '/' },
				{ text: this.$t('pages.bookings'), icon: 'mdi-bookmark', to: 'bookings' },
				{ text: this.$t('pages.services'), icon: 'mdi-content-cut', to: 'services' },
				{ text: this.$t('pages.opn_hrs'), icon: 'mdi-clock-outline', to: 'opnhrs' },
				{ text: this.$t('pages.absences'), icon: 'mdi-beach', to: 'absences' },
				{ text: this.$t('pages.customers'), icon: 'mdi-account', to: 'customers' },
				{ text: this.$t('pages.settings'), icon: 'mdi-cog', to: 'settings' }
			]
		}
	},

	methods: {
		async logout() {
			// Log out the user.
			await this.$store.dispatch('auth/logout')

			// Redirect to login.
			this.$router.push({ name: 'login' })
		}
	}
}
</script>

<style lang="scss" scoped></style>
